<script setup>
import {checkOrderApi, createOrderApi, productApi} from "@/service/index.js";
import {ref, defineEmits, onUnmounted} from 'vue'
import {ElMessage, ElButton, ElDivider, ElDialog} from "element-plus";
import VueQrcode from '@chenfengyuan/vue-qrcode'
import {useStore} from "vuex";
import mitts from "@/utils/mitt";
const store=useStore()
let priceList = ref([])
let priceInfo = ref({})
let type = ref(false)
let checkTimer = ref(null)
let checkStatus = ref(null)
let orderInfo = ref(null)
const emit = defineEmits(['close'])
productApi({}).then(res => {
  if (res.data.code == 1) {
    console.log(res.data.msg)
    priceList.value = res.data.msg
  }
})
const pruduct = () => {
  if (!priceInfo.value.money) {
    ElMessage({
      message: '请选择',
      type: 'warning',
    })
    return
  }
  type.value = true
  createOrderApi({
    pid: priceInfo.value.id,
    price: priceInfo.value.money,
    type: 1
  }).then(res => {
    if (res.data.code == 1) {
      console.log(res.data.data)
      orderInfo.value = res.data.data
      checkTimer.value = setInterval(() => {
        checkOrderApi({orderId: res.data.data.orderId}).then(res => {
          if (res.data.code == 1) {
            console.log('cg', res)
            clearInterval(checkTimer.value)
            ElMessage({
              message: '支付成功',
              type: 'success',
              duration:3000
            })
            mitts.emit('handleChange',true)
            setTimeout(()=>{
              store.dispatch('updateUserInfoStatus')
            },3000)
            emit('close')
          }
        })
      }, 2000)
    }
  })
}
onUnmounted(() => {

  clearInterval(checkTimer.value)
})
</script>

<template>
  <div class="r-box">
    <span class="label" style="text-align: center;padding: 5px;transform: translateY(-20px);margin-top: 20px;" >兑换币充值</span>
      <div class="r-item">
        <div class="r-m mme">
          <div class="r-m-item r" :class="{ac:priceInfo.id==i.id}" @click="priceInfo=i" v-for="i in priceList.list"
               :key="i.id">
            <div class="h" v-if="i.act_str">
              {{ i.act_str }}
            </div>
            <div class="c">
              <img src="@/assets/coin.png" alt="">
              <span class="cm">{{ i.score_buy }}  <span  v-if="i.act_str" class="cr"
                                                        style="color: red;font-size: 18px">+10%</span> </span>

            </div>
            <div class="s" v-if="i.score_give">
              <span>+{{ i.score_give }}</span>
            </div>
            <div class="s" v-else>
              <span>-</span>
            </div>
            <p class="m">
              ￥{{ i.money }}
            </p>
            <p class="mi" style="color: #dc3211" v-if="i.is_invite">
              （可开通邀请功能）
            </p>

          </div>
        </div>
      </div>
      <div class="r-item" style="display: flex;align-items: center; margin-top: 12px;">
      <span class="label" style="margin-left: 26px;">
        支付方式:
      </span>
        <div class="r-m" style="margin-bottom:0">
          <div class="r-m-item ac" style="display: flex;align-items: center;margin-bottom: 0px">
            <img src="@/assets/wx.png" style="margin-right: 10px" alt="">
            微信
          </div>
          <!--      <div class="r-m-item">-->
          <!--        <img src="/zfb.png" alt="">-->
          <!--        支付宝-->
          <!--      </div>-->
        </div>
      </div>

      <div class="bott">
        <el-button type="primary" @click="pruduct" style="width: 350px;height: 48px;margin-top: 10px;">去付款</el-button>
      </div>
  </div>
  <el-dialog
      v-model="type"
      :show-close="false"
      top="10px"
      width="600"
  >
    <template #default v-if="orderInfo&&orderInfo.reallyPrice" >
        <div data-v-2fb5d6b3="" style="text-align: center; border: 1px solid rgb(221, 221, 221); margin-bottom: 20px;"><img data-v-2fb5d6b3="" src="data:image/jpeg;base64,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" width="150"></div>
        <div data-v-2fb5d6b3=""
             style="background-color: yellow; color: red; padding: 5px 0px; font-size: 22px; text-align: center; font-weight: 600;">
          为了您正常支付 请务必付款 <span data-v-2fb5d6b3="" style="color: rgb(0, 0, 0); font-size: 28px;">{{ orderInfo.reallyPrice }}</span>
          元，备注说明无需填写，否则订单无法完成！如有疑问请联系客服。
        </div>
        <el-divider border-style="dashed"/>
        <img src="@/assets/pay.png" width="328px" style="margin: 0 auto; margin-left: 120px; " alt="">
        <div class="pay-box">
          <div data-v-2fb5d6b3="" style="font-size: 28px; font-weight: 600; text-align: center;  color: black;"> ￥{{ orderInfo.reallyPrice }}</div>
          <vue-qrcode id="qr" style="width: 300px;height: 300px" v-if="orderInfo.payUrl"
                      :value="orderInfo.payUrl"></vue-qrcode>
          <!--    <img :src="orderInfo.payUrl" alt="">-->
        </div>
        <el-divider border-style="dashed"/>
        <div class="notice">
          <div class="n-item">
            <div class="l">金额</div>
            <div class="m">{{ orderInfo.reallyPrice }}</div>
          </div>
          <div class="n-item">
            <div class="l">商户订单</div>
            <div class="m">{{ orderInfo.payId }}</div>
          </div>
          <div class="n-item">
            <div class="l">状态</div>
            <div class="m">{{ orderInfo.state == 0 ? ' 等待支付' : '支付成功' }}</div>
          </div>
        </div>
        <el-divider border-style="dashed"/>
        <div class="nn">
          <p>
            手机用户可保存上方二维码到手机中
          </p>
          <p>
            在微信扫一扫中选择“相册”即可

          </p>
        </div>
    </template>
  </el-dialog>
</template>

<style  lang="less" scoped>
.r-box {
  display: flex;
  flex-direction: column;

  .label {
    font-size: 25px;
    font-weight: bold;
  }
}

.r-item {
  display: flex;
}

.r-m {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;

  .r-m-item {
    margin-left: 20px;
    border: 1px solid #ebeef5;
    border-radius: 5px;
    width: 140px;
    padding: 5px;
    margin-bottom: 10px;
    cursor: pointer;
  }

  img {
    width: 30px;
    margin-right: 1px;
  }

  .ac {
    border-radius: 5px;
    border-color: #1677ff;
    color: #1677ff;
  }

  .r {
    font-size: 16px;
    padding: 10px 5px;
    text-align: center;
    padding-bottom: 0;
  }

}

.bott {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 15px 0;

  button {
  }
}

.pay-box {
  width: 300px;
  height: 300px;
  margin: 0 auto;
}

.notice {
  display: flex;
  flex-direction: column;
  align-items: center;

  .n-item {
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    width: 80%;
    color: black;
    margin: 2px 0;
  }

  .l {

  }

  .m {

  }
}

.nn {
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    margin: 0;
  }
}

#qr {
  width: 300px !important;
  height: 300px !important;
}

.mme {
  width: 100%;
  display: flex;
  padding: 0 0px;

  .ac {
    border-radius: 5px;
    border-color: #ebeef5;
    color: #1677ff;
    background: linear-gradient(#1677ff, #96b2da) !important;
  }

  .r-m-item {
    width: 180px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 10px;
    background: #f4f5f9;
    position: relative;

    .c {
      font-size: 20px;
      font-weight: bold;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: black;
      font-weight: bold;

      .cm {
        display: flex;
        margin: 5px 0;
        position: relative;
        font-size: 26px;

        .cr {
          position: absolute;
          right: -5px;
          transform: translate(110%, 20%);
        }
      }

      img {
        width: 30px;
        margin-bottom: 5px;
        margin-top: 15px;
      }

      span {
      }
    }

    .s {
      color: #ff2122;
      font-weight: bold;
      display: flex;
      align-items: center;
      font-size: 22px;
      transform: translate(-5px);

      img {
        width: 14px;
      }
    }

    .m {
      margin-top: 14px;
      font-weight: bold;
      color: rgba(48, 48, 48, 0.56);
      font-size: 17px;
    }

    .mi {
      margin-top: -20px;
      font-weight: bold;
      color: rgba(48, 48, 48, 0.56);
      font-size: 12px;
    }

    .h {
      border-radius: 5px;
      background: red;
      position: absolute;
      right: 0;
      top: 52px;
      color: white;
      width: 72px;
      height: 19px;
      border-radius: 9px 0 9px 0;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(red, orange);
    }
  }
}
</style>